'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var handlePhoneNumber = function (phone) {
    return {
        format: phone,
        number: phone.split(' ').join('').replace('+62', '0'),
        value: phone.split(' ').join('')
    };
};

exports.handlePhoneNumber = handlePhoneNumber;
//# sourceMappingURL=utils.js.map
